import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import Icon from "./Icon";
import Sidebar from "./Sidebar";
import ProfileIcon from "../assets/profile-icon.png";
import SearchIcon from "../assets/search-icon.png";
import { useSelector } from "react-redux";
import SearchBar from "./SearchBar";

export default function TopBar({
  setLanguage,
  eventData,
  formattedCurrentDate,
  hasScrolled = false,
}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [mobileSearchActive, setMobileSearchActive] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const user = useSelector((state) => state.user);

  const handleSearchClick = () => {
    setIsSearchActive(true);
    // Scroll to top of page
    window.scrollTo({ top: 0, behavior: "smooth" });
    // Toggle search active state
    setMobileSearchActive(!mobileSearchActive);
  };

  const handleSearchDismiss = () => {
    setMobileSearchActive(false);
  };

  return (
    <>
      <div
        className={`max-lg:bg-[#17131F] lg:hidden w-full flex items-center justify-center fixed top-0 ${
          isSearchActive ? "z-[99999999]" : "z-[9999]"
        } transition-all duration-300 border-b border-[#25202E] px-[16px] py-[18px]
        `}
      >
        <div className="flex justify-between items-center w-full">
          <button
            onClick={() => {
              setSidebarOpen(true);
            }}
          >
            <Icon
              icon="heroicons:bars-3"
              className="w-[24px] h-[24px] text-neutral-100"
              alt="Menu"
            />
          </button>
          <Link
            className={`flex items-center justify-center pl-[40px] ${
              isHomePage ? "pl-[40px]" : "pl-[0px]"
            }`}
            to="/?city=all_cities"
          >
            <Logo />
          </Link>
          <div className="flex items-center gap-[12px]">
            <button
              onClick={isHomePage ? handleSearchClick : null}
              className={!isHomePage ? "opacity-0" : ""}
            >
              <img
                src={SearchIcon}
                className="w-[28px] h-[28px]"
                alt="Search"
              />
            </button>
            <Link
              to={`${user.id ? `/profile` : "/email-login"}`}
              className="flex items-center"
            >
              <img
                src={ProfileIcon}
                className="w-[28px] h-[28px]"
                alt="Profile"
              />
            </Link>
          </div>
        </div>

        {/* Mobile Search Bar */}
        <div
          className={`absolute z-[1000] top-full left-0 right-0 w-full px-[16px] py-[12px] bg-[#12041f]/95 backdrop-blur-md transition-all duration-300 ${
            mobileSearchActive ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <SearchBar
            eventData={eventData}
            formattedCurrentDate={formattedCurrentDate}
            isMobile={true}
            onSearchDismiss={handleSearchDismiss}
            isSearchActive={isSearchActive}
            setIsSearchActive={setIsSearchActive}
          />
        </div>
      </div>

      {/* Mobile Sidebar Drawer */}
      <div
        className={`fixed inset-0 z-[1000000] lg:hidden transition-opacity duration-300 ${
          sidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        {/* Backdrop */}
        <div
          className="absolute inset-0 bg-[#000000]"
          onClick={() => setSidebarOpen(false)}
        />

        {/* Sidebar */}
        <div
          className={`fixed top-0 left-0 h-full w-[100vw] bg-[#000000] transform transition-transform duration-300 ease-in-out ${
            sidebarOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="z-[1000000] relative h-full">
            {/* Close button */}
            <button
              onClick={() => setSidebarOpen(false)}
              className="top-[28px] left-[24px] absolute text-white"
            >
              <Icon icon="heroicons:x-mark" className="w-[30px] h-[30px]" />
            </button>

            {/* Sidebar content */}
            <Sidebar
              setLanguage={setLanguage}
              isMobile={true}
              onClose={() => setSidebarOpen(false)}
            />
          </div>
        </div>
      </div>
    </>
  );
}
